import { RelationshipsRelativeItemModel } from 'forms/sections/relationships/relatives/types';
import { ListItemModel } from 'forms/shared/types';
import { DeepSafePartial } from 'types/types';

interface FilteredParent {
  fieldPosition: number[]
  includesIDK: boolean
  idkPosition: number[]
}

interface ParentMap {
  [key: string]: FilteredParent
}

export const getFilteredParentInfo = (items: (DeepSafePartial<ListItemModel<RelationshipsRelativeItemModel>> | undefined)[] | undefined) => {
  const parents: ParentMap = {};
  if (items) {
    items.forEach((obj: DeepSafePartial<ListItemModel<RelationshipsRelativeItemModel>> | undefined, index: number) => {
      const relationValue = obj?.Item?.Relation?.value || '';
      const includesIDK = obj?.Item?.ParentNotApplicable?.applicable === false;
      if (['Mother', 'Father', 'Mother-in-law', 'Father-in-law'].includes(relationValue)) {
        if (parents[relationValue]) {
          parents[relationValue].fieldPosition.push(index);
          if (includesIDK) {
            parents[relationValue].includesIDK = true;
            parents[relationValue].idkPosition.push(index);
          }
        } else {
          parents[relationValue] = {
            includesIDK, idkPosition: includesIDK ? [index] : [], fieldPosition: [index]
          };
        }
      }
    });
  }
  return parents;
};

export const parentInfoContainsErrors = (items: (DeepSafePartial<ListItemModel<RelationshipsRelativeItemModel>> | undefined)[] | undefined) => {
  const filteredParentInfo: ParentMap = getFilteredParentInfo(items);
  let containsErrors = false;
  for (const [key, obj] of Object.entries(filteredParentInfo)) {
    const count = obj.fieldPosition.length;
    if (count > 1 && obj.includesIDK) {
      containsErrors = true;
    }
  }
  return containsErrors;
};
